import { render, staticRenderFns } from "./UmbracoImageExt.vue?vue&type=template&id=f7a4fcde"
import script from "./UmbracoImageExt.vue?vue&type=script&lang=js"
export * from "./UmbracoImageExt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports